import {

  Search,
  CalendarDays,
  Filter,
  RotateCcw

} from "lucide-react";

import FilterChip
from "./FilterChip";

export default function FilterBar({

  search,
  setSearch,

  date,
  setDate,

  selectedManager,
  setSelectedManager,

  managers = [],

  role,

  clearFilters

}) {

  return (

    <div
      className="
      bg-white
      rounded-3xl
      p-6
      shadow-sm
      border
      border-gray-100
      space-y-5
    "
    >

      {/* =====================================
          TOP
      ===================================== */}

      <div
        className="
        flex
        items-center
        justify-between
      "
      >

        <div
          className="
          flex
          items-center
          gap-3
        "
        >

          <div
            className="
            w-12
            h-12
            rounded-2xl
            bg-primary/10
            text-primary
            flex
            items-center
            justify-center
          "
          >

            <Filter size={22} />

          </div>

          <div>

            <h2
              className="
              text-xl
              font-bold
              text-gray-800
            "
            >
              Filters
            </h2>

            <p
              className="
              text-sm
              text-gray-500
            "
            >
              Search and filter claims
            </p>

          </div>

        </div>

        {/* CLEAR */}

        <button
          onClick={clearFilters}
          className="
          flex
          items-center
          gap-2
          px-4
          py-2
          rounded-2xl
          bg-gray-100
          hover:bg-gray-200
          transition
          text-sm
          font-semibold
        "
        >

          <RotateCcw size={16} />

          Clear Filters

        </button>

      </div>

      {/* =====================================
          FILTERS
      ===================================== */}

      <div
        className="
        grid
        grid-cols-1
        md:grid-cols-2
        xl:grid-cols-3
        gap-4
      "
      >

        {/* SEARCH */}

        <div
          className="
          flex
          items-center
          bg-gray-100
          rounded-2xl
          px-4
          border
          border-transparent
          focus-within:border-primary
          transition
        "
        >

          <Search
            size={18}
            className="
            text-gray-400
          "
          />

          <input
            type="text"
            placeholder="Search customer or mobile"
            value={search}
            onChange={(e) =>
              setSearch(
                e.target.value
              )
            }
            className="
            w-full
            bg-transparent
            outline-none
            border-none
            px-3
            py-4
            text-sm
          "
          />

        </div>

        {/* DATE */}

        <div
          className="
          flex
          items-center
          bg-gray-100
          rounded-2xl
          px-4
          border
          border-transparent
          focus-within:border-primary
          transition
        "
        >

          <CalendarDays
            size={18}
            className="
            text-gray-400
          "
          />

          <input
            type="date"
            value={date}
            onChange={(e) =>
              setDate(
                e.target.value
              )
            }
            className="
            w-full
            bg-transparent
            outline-none
            border-none
            px-3
            py-4
            text-sm
          "
          />

        </div>

        {/* CEO MANAGER FILTER */}

        {
          role === "ceo"

          && (

            <select
              value={
                selectedManager
              }
              onChange={(e) =>
                setSelectedManager(
                  e.target.value
                )
              }
              className="
              bg-gray-100
              rounded-2xl
              px-4
              py-4
              outline-none
              border
              border-transparent
              focus:border-primary
              transition
              text-sm
            "
            >

              <option value="">
                All Managers
              </option>

              {
                managers.map(
                  (m) => (

                    <option
                      key={m.id}
                      value={m.id}
                    >
                      {m.name}
                    </option>
                  )
                )
              }

            </select>
          )
        }

      </div>

      {/* =====================================
          ACTIVE FILTERS
      ===================================== */}

      <div
        className="
        flex
        flex-wrap
        gap-3
      "
      >

        <FilterChip
          label="Search"
          value={search}
          onRemove={() =>
            setSearch("")
          }
        />

        <FilterChip
          label="Date"
          value={date}
          onRemove={() =>
            setDate("")
          }
        />

      </div>

    </div>
  );
}